export default "__VITE_ASSET__f3581581__"